export default __webpack_public_path__ + "static/media/3h.4781bc3e.png";